/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-09-09 18:43:41
 * @LastEditors: changfeng
 * @LastEditTime: 2024-09-24 11:15:37
 */
import React from "react";
// STEP #1: At the start of your file, import airwallex-payment-elements package
import { redirectToCheckout, loadAirwallex } from "airwallex-payment-elements";

const currency = "USD";

const testEnv = {
	env: "demo",
	successUrl: "https://test.adsurgebot.com/billing/history",
	failUrl: "https://test.adsurgebot.com/billing/history"
};
const prodEnv = {
	env: "prod",
	successUrl: "https://www.adsurgebot.com/billing/history",
	failUrl: "https://www.adsurgebot.com/billing/history"
};

const envMap = {
	demo: testEnv,
	prod: prodEnv
};

const currentEnv = envMap["prod"];
// const currentEnv = envMap["demo"];
const redirectHppForCheckout = (intent_id: string, client_secret: string) => {
	redirectToCheckout({
		env: currentEnv.env,
		mode: "payment",
		currency,
		intent_id, // Required, must provide intent details
		client_secret, // Required
		successUrl: currentEnv.successUrl, // Must be HTTPS sites
		failUrl: currentEnv.failUrl // Must be HTTPS sites
		// For more detailed documentation at https://github.com/airwallex/airwallex-payment-demo/tree/master/docs#redirectToCheckout
	});
};

export const redirectHpp = async (intent_id: string, client_secret: string) => {
	try {
		await loadAirwallex({
			env: currentEnv.env // Can choose other production environments, 'staging' | 'demo' | 'prod'
		});
		redirectHppForCheckout(intent_id, client_secret);
	} catch (error) {
		console.log("There was an error with HPP redirection", error);
	}
};
